import { ComponentProps, FC, ReactElement } from 'react';
import { Box, Colors, Typography } from '@altermaind/web/ui';

type Props = Omit<ComponentProps<typeof Typography>, 'componentName' | 'data-testid' | 'children'> &
  ComponentProps<typeof Box> & {
    children: ReactElement | string | null | number;
    avoidEllipsis?: boolean;
    inError?: boolean;
    color?: keyof Colors;
  };

export const ValueInTable: FC<Props> = ({ children, avoidEllipsis, inError, color, ...props }) => {
  return (
    <Typography
      variant='p2/light'
      as='span'
      color={inError ? 'error/bright' : color || 'primary/text'}
      style={
        !avoidEllipsis
          ? {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }
          : {}
      }
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {children}
    </Typography>
  );
};
